export default "/images/oral_health_daily_practices_sm.jpg?6eb32be84306c71d6b10ba707e7cc0f4";